// extracted by mini-css-extract-plugin
export default {"arrow":"outlet-btn_arrow__WoiHQ","btn":"outlet-btn_btn__Hwb49"};